import { useEffect, useRef, useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { syncAllChannelImages } from '@/lib/api/products'

/**
 * Synct beim Öffnen Bilder über alle Channels (nur fehlende) im Hintergrund.
 * Bei neu hinzugefügten Bildern werden Image-/Asset-Queries invalidiert.
 * Fehler sind still (nächster Aufruf versucht es erneut).
 * Gibt zurück, ob der Sync gerade läuft (für den Sync-Indikator im Hero).
 */
export function useChannelImagesSync(productId: string | undefined): boolean {
  const queryClient = useQueryClient()
  const triggeredRef = useRef(false)
  const [active, setActive] = useState(false)

  useEffect(() => {
    if (!productId || triggeredRef.current) return
    triggeredRef.current = true
    setActive(true)
    syncAllChannelImages(productId)
      .then((res) => {
        if ((res.total_added ?? 0) > 0) {
          queryClient.invalidateQueries({ queryKey: ['product-images', productId] })
          queryClient.invalidateQueries({ queryKey: ['product-assets', productId] })
        }
      })
      .catch(() => {
        /* still: kein Error-Toast, Retry beim nächsten Öffnen */
      })
      .finally(() => setActive(false))
  }, [productId, queryClient])

  return active
}
